module.exports = __webpack_public_path__ + "static/media/twitter-white.de86fd9c.svg";